const RegEx = () => {
    const getPriceComma = (num) =>{
        const regexp = /\B(?=(\d{3})+(?!\d))/g;
        return `${num.toString().replace(regexp, ',')}원`;
    }
    return {
        getPriceComma
    }
  };
  
  export default RegEx();


// WEBPACK FOOTER //
// ./src/util/Regex.js